module.exports = __webpack_public_path__ + "static/tasklong-4d6b22e2ad15067db6c906ea542f791c.jpg";